/* eslint-disable sort-keys */
import {
    GLASS_DIAMETER,
    GLASS_HEIGHT,
    MANUFACTURER,
    MATERIAL,
    NET_VOLUME,
    PREMIUM_PACK,
    PRODUCTION_METHOD_HB,
    SUITABLE,
    COUNTRY,
} from 'modules/product-card/constants/characteristics';

const HEADER = [SUITABLE, MANUFACTURER, COUNTRY, NET_VOLUME, GLASS_HEIGHT, GLASS_DIAMETER, PREMIUM_PACK];
const DETAILED = [MATERIAL, PRODUCTION_METHOD_HB];
const TABLET = [...HEADER, ...DETAILED];

export const STEKLO_CHARACTERISTICS = {
    HEADER,
    DETAILED,
    TABLET,
};
